import { CheckMark } from '@lyearn/icons';
import { isValidSubmission } from '@/modules/corporate/modules/questions/fields/single-select/utils';
import { QuizViewField } from '@/modules/corporate/modules/questions/fields/types';
import { QuestionTypeEnum } from '@/types/schema';

import Player from '../../../components/Player';
import QuestionReview from '../../../components/QuestionReview';
import { getQuestionEvaluation } from './../../utils';

const MultiSelectViewField: QuizViewField = {
  getQuestionEvaluation,
  isValidSubmission,
  Player,
  type: QuestionTypeEnum.MultiSelect,
  getQuestionLabel: () => 'QuizPlayer:MultiSelect',
  labelKey: 'QuizPlayer:QuestionType.MultiSelect',
  Icon: CheckMark,
  Review: QuestionReview,
};

export default MultiSelectViewField;
